import SingleFeature from "./SingleFeature";
export default SingleFeature;
